import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from './api/auth.service';
import { UsersService } from './api/users.service';
import { HttpClientModule } from '@angular/common/http';
import { AlertVisualizationService } from './api/alert-visualization.service';
import { AlertFilterOptionsService } from './api/alert-filter-options.service';
import { ServiceInterceptorsProviders } from './api/interceptors/services.interceptors';
import { UtilsService } from './api/utils.service';
import { AlertValidationService } from './api/alert-validation.service';
import { AlertValidationFilterOptionsService } from './api/alert-validation-filter-options.service';
import { AlertManagementFilterOptionsService } from './api/alert-management-filter-options.service';
import { ExtraLayerService } from './api/extra-layer.service';
import { LoadingHttpInterceptor } from './api/interceptors/request.loading.interceptor';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [],
  providers: [
    AuthService,
    UsersService,
    //
    AuthService,
    AlertVisualizationService,
    AlertValidationService,
    UtilsService,
    ExtraLayerService,
    AlertFilterOptionsService,
    AlertValidationFilterOptionsService,
    AlertManagementFilterOptionsService,
    ServiceInterceptorsProviders,
    LoadingHttpInterceptor
  ]
})
export class ServicesModule { }
